<template>
  <v-card elevation="7" color="green lighten-3">
    <v-form>
      <v-container>
        <v-row>
          <v-col cols="12" md="4" sm="3" xs="2">
            <h3>Filtro</h3>
          </v-col>
          <v-col cols="12" md="3" sm="2" xs="1">
            <v-menu v-model="menu1" :close-on-content-click="false" min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="computedDateFormattedMomentDataInicial"
                  clearable
                  label="Inicial"
                  prepend-icon="mdi-calendar"
                  v-on="on"
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                color="green lighten-3"
                v-model="dataInicial"
                @change="menu1 = false"
                locale="pt-br"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="3" sm="2" xs="1">
            <v-menu v-model="menu2" :close-on-content-click="false" min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="computedDateFormattedMomentDataFinal"
                  clearable
                  label="Final"
                  prepend-icon="mdi-calendar"
                  v-on="on"
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                color="green lighten-3"
                v-model="dataFinal"
                @change="menu2 = null"
                locale="pt-br"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="2" sm="1" xs="1">
            <div class="my-2">
              <v-btn @click="adicionarFiltroDatasState" color="primary" dark>
                <v-icon left>mdi-card-search</v-icon>Buscar
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import moment from "moment";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";

export default {
  data: () => ({
    contClick: 0,
    dataInicial: new Date().toISOString().substr(0, 10),
    dataFinal: new Date().toISOString().substr(0, 10),
    menu1: false,
    menu2: false
  }),
  computed: {
    computedDateFormattedMomentDataInicial() {
      return this.dataInicial
        ? moment(this.dataInicial).format("DD/MM/YYYY")
        : "";
    },
    computedDateFormattedMomentDataFinal() {
      return this.dataFinal ? moment(this.dataFinal).format("DD/MM/YYYY") : "";
    },
    ...mapGetters({
      clickBtnFiltroData: "clickFiltroData"
    })
  },
  methods: {
    ...mapActions([
      "adicionarFiltroDataInicio",
      "adicionarFiltroDataFinal",
      "clickFiltroData"
    ]),
    adicionarFiltroDatasState() {
      if (this.contClick != null) {
        this.contClick += 1;
        const dataInicio = this.dataInicial;
        const dataFim = this.dataFinal;
        this.$store.dispatch("adicionarFiltroDataInicio", dataInicio);
        this.$store.dispatch("adicionarFiltroDataFinal", dataFim);
        this.$store.dispatch("clickFiltroData", this.contClick);
      } else {
        this.contClick += 1;
        const dataInicio = this.dataInicial;
        const dataFim = this.dataFinal;
        this.$store.dispatch("adicionarFiltroDataInicio", dataInicio);
        this.$store.dispatch("adicionarFiltroDataFinal", dataFim);
        this.$store.dispatch("clickFiltroData", this.contClick);
      }
    }
  }
};
</script>

<style>
</style>